/**
 * トーナメント（シングルエリミネーション）のブラケット生成
 */
import { TournamentMatch } from '../types/Tournament';

/**
 * 8名シングルエリミネーションのブラケットを生成する。
 * 準々決勝4試合 + 準決勝2試合 + 決勝1試合 = 7試合
 *
 * 準々決勝には全8名が配置され、準決勝以降は空文字列（勝者が後から配置される）。
 *
 * @param participantIds 参加者IDの配列（8名）
 * @returns 全試合の配列
 * @throws 参加者が8名未満の場合
 */
export function generateEliminationBracket(participantIds: string[]): TournamentMatch[] {
  if (participantIds.length !== 8) {
    throw new Error(`Exactly 8 participants required, got ${participantIds.length}`);
  }

  const matches: TournamentMatch[] = [];
  let matchIndex = 0;

  // 準々決勝（round=0）: 4試合
  for (let i = 0; i < 4; i++) {
    matches.push({
      matchIndex,
      participant1Id: participantIds[i * 2],
      participant2Id: participantIds[i * 2 + 1],
      round: 0,
    });
    matchIndex++;
  }

  // 準決勝（round=1）: 2試合
  for (let i = 0; i < 2; i++) {
    matches.push({
      matchIndex,
      participant1Id: '',
      participant2Id: '',
      round: 1,
    });
    matchIndex++;
  }

  // 決勝（round=2）: 1試合
  matches.push({
    matchIndex,
    participant1Id: '',
    participant2Id: '',
    round: 2,
  });

  return matches;
}
